import React from "react";

export default function buildLazyScreenResolver(screenContext) {
  const screenPaths = screenContext.keys().reduce((registry, path) => {
    const screenName = path.replace("./", "").replace(/\.js$/, "").split("/").pop();
    registry[screenName] = path;
    return registry;
  }, {});

  const lazyScreens = {};

  return function resolveScreenComponent(view) {
    const screenPath = screenPaths[view];

    if (!screenPath) {
      return null;
    }

    if (!lazyScreens[view]) {
      lazyScreens[view] = React.lazy(() =>
        screenContext(screenPath).then((module) => ({ default: module.default || module }))
      );
    }

    return lazyScreens[view];
  };
}
